import React, { useState, useEffect } from 'react'
//Bibliotecas
import FlexContainer from '../../components/common/FlexContainer'
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
//Componentes
import Table from './Components/Table'
import SelectCurso from './Components/SelectCurso';
import SelectOva from './Components/SelectOva';
//Servicios
import ProgresoService from '../../services/ProgresoService';
import CursoService from '../../services/CursoService';

//Imágenes
import { Search, Circle } from 'react-feather';

export default function Progeso() {

  //Params
  let { codigo } = useParams();
  let { nombreCurso } = useParams();



  //Estados
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [cursos, setCursos] = useState('');
  const [cursoSelection, setCursoSelection] = useState(nombreCurso);
  const [ovas, setOvas] = useState([{ nombre: "Industrias 4.0", _id: "6282e29457a90717159e6c16" }, { nombre: "Fundamentos de programación", _id: "6297fa739376813930f69912" }, { nombre: "Componentes electrónicos y Arduino", _id: "62d6dcea3be48a71d1bbf29d" }, { nombre: "Global" }]);
  const [ovaSelection, setOvaSelection] = useState(ovas[0].nombre);
  const [ovaID, setOvaID] = useState(ovas[0]._id);

  //Filtros de Tabla
  const filtrar = (data) => {
    return data.filter((item, index) =>
      item.estudiantes[0]?.nombre?.toLowerCase().includes(search.toLowerCase()) ||
      item.estudiantes[1]?.nombre?.toLowerCase().includes(search.toLowerCase()) ||
      item.estudiantes[2]?.nombre?.toLowerCase().includes(search.toLowerCase()));
  }

  //Actualizar información de la tabla
  function updateCurso(codigo) {
    ProgresoService.obtenerProgresoCurso(codigo).then((res) => {
      setData(res[0].grupos);
      console.log(res[0].grupos);
    })
  }


  //Cargar datos iniciales
  useEffect(() => {
    updateCurso(codigo);
    CursoService.obtenerCursos().then((res) => {
      setCursos(res);
    })
  }, [])


  return (
    <FlexContainer minHeight='100vh' width='100%' justifyContent='center' alignItems='center' textAlign='center' backgroundColor='transparent'>
      <Title>Seguimiento del progreso</Title>
      <FlexContainer width='80%' flexDirection='column' padding='64px' borderRadius='20px' boxShadow='20px 20px 40px rgba(0, 0, 0, 0.25)' margin='32px 0px' justifyContent='flex-start' minHeight='600px'>
        <FlexContainer flexDirection='row' >
          <SelectCurso options={cursos} selection={cursoSelection} setSelection={setCursoSelection} updateData={updateCurso}></SelectCurso>
          <SelectOva options={ovas} selection={ovaSelection} setSelection={setOvaSelection} setOvaID={setOvaID}></SelectOva>
          <SearchInput>
            <input type="text" placeholder="Buscar..." onChange={(e) => { setSearch(e.target.value); console.log(filtrar(data)) }}></input>
            <Search></Search>
          </SearchInput>
        </FlexContainer>
        <Table data={filtrar(data)} ova={ovaID} ovaSelection={ovaSelection} ovas={ovas}></Table>
        {data.length != 0 && 
          <Info>
            <div>
              <Circle className='ok' />
              <span>Actividad completada</span>
            </div>
            <div>
              <Circle className='not-ok' />
              <span>Actividad no completada</span>
            </div>
          </Info>
        }
      </FlexContainer>
    </FlexContainer>
  )
}


const Title = styled.h1`
    color:var(--color-blanco);
`;

const SearchInput = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    border-radius:5px;
    border:2px solid var(--color-morado-oscuro);
    input{
        border:none;
        padding:8px;
        border-radius:5px; 
        &:focus{
          outline:none;
        }
    }
    svg{
      width:24px;
      color: var(--color-gris-oscuro);
      padding:8px;
    }
`;


const Info = styled.div`
    margin-top:40px;
    align-self:center;
    background-color:var(--color-gris-claro);
    padding:16px;
    border-radius:10px;
    div{
      display:flex;
      svg{
        margin-right:8px;
        stroke: none;
        width:16px;
      }
      .ok{
          fill: #7FFFAA;
        }
      .not-ok{
          fill: #FEBE32;    
      }
    }
`;